/*
 * @Description: l3存在顶柜的时候所需要的处理内容
 * @Author: Dai Guo
 * @Date: 2022-05-09 17:13:29
 * @LastEditors: Kun Yang
 * @LastEditTime: 2022-05-16 13:58:17
 */
import { Vector3 } from '@babylonjs/core';
import MeshManage from '../meshManage';
import { BASICTYPE_ENUM } from '../utils/enum';
import { DEFAULTSEALPLATEDEPTH, FRAMEDEPTH, TOPFRAME_GROUND, } from '../utils/kitchenConfig';
import { checkFrameIsHighFrame, getDefaultDoor } from '../utils/renderUtils';
import BaseLength from './baseLength';
class LengthP2XTop extends BaseLength {
    // L型顶柜换位置，位置的获取与正常逻辑不一样
    static getSealPlatePos(templateJson, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const frameLenghth = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length3) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        const otherLength = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length3) === null || _e === void 0 ? void 0 : _e.otherSealPlateLength;
        const lastFrame = frameLenghth ? (_g = (_f = templateJson[type]) === null || _f === void 0 ? void 0 : _f.length3) === null || _g === void 0 ? void 0 : _g.frames[frameLenghth - 1]
            : (_j = (_h = templateJson[type]) === null || _h === void 0 ? void 0 : _h.length3) === null || _j === void 0 ? void 0 : _j.frames[0];
        const lastPreFrame = frameLenghth >= 3 ? (_l = (_k = templateJson[type]) === null || _k === void 0 ? void 0 : _k.length3) === null || _l === void 0 ? void 0 : _l.frames[frameLenghth - 2]
            : null;
        // 只有一个柜体（转角柜）
        if (frameLenghth === 1 && ((_o = (_m = templateJson[type]) === null || _m === void 0 ? void 0 : _m.length3) === null || _o === void 0 ? void 0 : _o.sealPlate)) {
            return null;
        }
        // otherSealPlateLength是否存在 存在就在最后一个普通柜后面
        if (otherLength && ((_q = (_p = templateJson[type]) === null || _p === void 0 ? void 0 : _p.length3) === null || _q === void 0 ? void 0 : _q.sealPlate)) {
            // 最后一个是高柜，返回倒数第二
            if (checkFrameIsHighFrame(lastFrame)) {
                // 是否是双高柜
                if (lastPreFrame && checkFrameIsHighFrame(lastPreFrame)) {
                    return frameLenghth - 2;
                }
                return frameLenghth - 1;
            }
            // 没有高柜，但是有otherLength，补板只会在最后一个普通柜前面
            if (frameLenghth > 1) {
                return frameLenghth;
            }
            // 最后一个普通柜
            return frameLenghth;
        }
        // 默认返回没有柜体
        return null;
    }
    /**
     *
     * @param sealPlateData 补板数据
     * @param preMeshManage 补板在哪一个柜体前面 meshMange
     * @param type 顶柜/地柜
     * @param frameData 补板在哪一个柜体后面 柜体数据
     * @param _this this：添加到模型管理器使用
     * @returns 地柜：补板的meshMange 顶柜：正前方的meshManage
     */
    renderSealPlate(sealPlateData, preMeshManage, type, frameData, _this) {
        var _a, _b;
        if (!sealPlateData.length) {
            return null;
        }
        let sealPlateMesh;
        const { componentBasic: { id } } = frameData;
        let scaleX = 0;
        let scaleY = 0;
        let scaleZ = 0;
        const moveZ = preMeshManage.getModelSize().z / 2;
        let nextMeshManage = null;
        // 获取柜体门板的厚度
        const defalutDoor = getDefaultDoor(_this.templateJson, 'length3', type);
        const defalutDoorMesh = new MeshManage(_this.scene.getMeshByName((_a = defalutDoor === null || defalutDoor === void 0 ? void 0 : defalutDoor.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        const drawerDoorDeepSize = ((_b = defalutDoorMesh === null || defalutDoorMesh === void 0 ? void 0 : defalutDoorMesh.getModelSize()) === null || _b === void 0 ? void 0 : _b.z) || DEFAULTSEALPLATEDEPTH;
        const defaluFrameData = new MeshManage(_this.scene.getMeshByName(id));
        // 添加到模型管理器，清楚模型时使用
        this.initSealPlate(sealPlateData, _this);
        switch (type) {
            case BASICTYPE_ENUM.top:
                // eslint-disable-next-line no-param-reassign
                _this.sealPlateData = sealPlateData; // 记录补板数据
                sealPlateMesh = new MeshManage(_this.scene.getMeshByName(sealPlateData[0].id));
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c;
                    sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                    if (!(sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.mesh)) {
                        sealPlateMesh = preMeshManage;
                        return;
                    }
                    switch (plateInx) {
                        case 0:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_a = this.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // 设置旋转角度
                            this.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson) - sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z + moveZ - sealPlateMesh.getModelSize().z,
                            });
                            break;
                        case 1:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = defaluFrameData.getModelSize().y / sealPlateMesh.getModelSize().y;
                            scaleZ = drawerDoorDeepSize / sealPlateMesh.getModelSize().z;
                            (_b = this.sealPlate) === null || _b === void 0 ? void 0 : _b.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson) - preMeshManage.getModelSize().y,
                                z: preMeshManage.mesh.position.z + moveZ - sealPlateMesh.getModelSize().z * 0.5 - FRAMEDEPTH.TOP,
                            });
                            // 顶柜的补板，需要返回正面的mesh 补板后面柜体需要移动
                            nextMeshManage = sealPlateMesh;
                            break;
                        case 2:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(_this.scene.getMeshByName(plate.id));
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(_this.templateJson) - preMeshManage.getModelSize().y
                                    + sealPlateMesh.getModelSize().y * 0.5,
                                z: preMeshManage.mesh.position.z + moveZ - sealPlateMesh.getModelSize().z,
                            });
                            break;
                        default:
                            break;
                    }
                });
                return nextMeshManage;
                break;
            default:
                return null;
                break;
        }
    }
}
export default LengthP2XTop;
